"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimeListEmpty;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeListEmpty(_ref) {
  var polyglot = _ref.polyglot;

  return _react2.default.createElement(
    "div",
    { className: "dates-empty" },
    _react2.default.createElement("span", { className: "icon-cg-clock" }),
    _react2.default.createElement("br", null),
    _react2.default.createElement("br", null),
    polyglot.t('events.form.calendar.selectDate')
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DatesBox/DateListEmpty.js
// module id = 2208
// module chunks = 0